<template>
  <section id="about" class="rt-section mission">
    <div class="rt-inner">
      <span class="rt-eyebrow mission__eyebrow">OUR MISSION</span>
      <h2 class="mission__title">音楽の権利を、もっと自由に、<br>もっとシンプルに。</h2>
      <p class="mission__lead">
        権利者とビジネスの双方が安心できる環境を、システムと人の両輪でつくります。
        複雑な権利処理を、私たちが軽やかに。音楽が生まれ、届き、めぐっていく——
        その裏側を、ていねいに支えています。
      </p>
    </div>
  </section>
</template>

<script>
export default { name: 'HomeMission' }
</script>

<style scoped>
.mission {
  background: var(--surface);
  text-align: center;
}

.mission__eyebrow {
  color: var(--brand-green);
  background: var(--green-bg);
}

.mission__title {
  font-size: clamp(22px, 4vw, 28px);
  font-weight: 700;
  line-height: 1.6;
  color: var(--ink);
}

.mission__lead {
  font-size: 15px;
  line-height: 2;
  color: var(--ink-soft);
  max-width: 560px;
  margin: 18px auto 0;
}
</style>
